import React from 'react';
import { getUpcomingAppointmentDetail } from 'api/zoom';
import { TServerCalendarAppointmentEventDetail } from 'types/calendar';

const useGetCommingAppointment = (
    curentAppointmentId?: number,
): [TServerCalendarAppointmentEventDetail | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TServerCalendarAppointmentEventDetail | undefined>();
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getUpcomingAppointmentDetail(curentAppointmentId!);
            if (!result.error) {
                const data: TServerCalendarAppointmentEventDetail[] = result?.data?.data || undefined;
                if (data.length > 0) {
                    setItems(data[0]);
                }
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (curentAppointmentId) {
            setItems(undefined);
            fetchData();
        }
    }, [curentAppointmentId]);

    return [items, loading, fetchData];
};

export default useGetCommingAppointment;
